import { render, staticRenderFns } from "./rateTable.vue?vue&type=template&id=4789b819&scoped=true&"
import script from "./rateTable.vue?vue&type=script&lang=js&"
export * from "./rateTable.vue?vue&type=script&lang=js&"
import style0 from "./rateTable.vue?vue&type=style&index=0&id=4789b819&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4789b819",
  null
  
)

export default component.exports